export default "__VITE_ASSET__b95eb4f5__"